export default "__VITE_ASSET__BM2tHw75__"